import { render } from "./BatchDetailsCard.vue?vue&type=template&id=76816b80&ts=true"
import script from "./BatchDetailsCard.vue?vue&type=script&lang=ts"
export * from "./BatchDetailsCard.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__